import * as React from 'react';
import { CardBottomPrices } from './CardBottomPrices';
import { CommonComponentsProvider } from '../../index';
const CampaignCardBottom = (props) => {
    const { tier, app, language, isTestEnvironment, disableTranslationsStatistics, regularPrice, regularPricePerUser, discounts, translations, hideSeparatorOnTop, } = props;
    return (React.createElement(CommonComponentsProvider, { language: language, tier: tier, app: app, isTestEnvironment: isTestEnvironment, translations: translations, disableTranslationsStatistics: disableTranslationsStatistics },
        React.createElement(CardBottomPrices, { app: app, tier: tier, language: language, regularPrice: regularPrice, regularPricePerUser: regularPricePerUser, discounts: discounts, hideSeparatorOnTop: hideSeparatorOnTop })));
};
export { CampaignCardBottom };
